import { useEffect, useState } from "react";
import type { DataLoadStatus } from "../types";
import { loadCoreData, type CoreDataBundle } from "../data/loaders/coreData";
import { loadDailyCoreData } from "../data/dailyAnalysisClient";
import { DAILY_ANALYSIS_ENABLED } from "../data/dailyAnalysisConfig";

const INITIAL_STATUS: DataLoadStatus = {
  state: "idle",
  issues: [],
  loadedSeries: 0,
  expectedSeries: 0
};

export function useCoreData() {
  const [data, setData] = useState<CoreDataBundle | null>(null);
  const [status, setStatus] = useState<DataLoadStatus>(INITIAL_STATUS);

  useEffect(() => {
    const controller = new AbortController();
    setStatus({ ...INITIAL_STATUS, state: "loading" });
    (DAILY_ANALYSIS_ENABLED ? loadDailyCoreData(controller.signal) : loadCoreData(controller.signal))
      .then((bundle) => {
        if (controller.signal.aborted) return;
        setData(bundle);
        setStatus(bundle.status);
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        setStatus({
          state: "error",
          issues: [{
            id: "core-loader-fatal",
            severity: "error",
            scope: "core-loader",
            message: error instanceof Error ? error.message : String(error)
          }],
          loadedSeries: 0,
          expectedSeries: 0
        });
      });
    return () => controller.abort();
  }, []);

  return { data, status };
}
